import React from "react";
import { CheckCircle} from 'lucide-react'

type CategoryBoxProps = {
  category: { id: number; name: string };
  isSelected: boolean;
  onSelect: (cat: { id: number; name: string }) => void;
  onRemove: (id: number) => void;
};

export default function CategoryBoxSelect ({ category, isSelected, onSelect, onRemove }:CategoryBoxProps){
  const handleClick = () => {
    if (isSelected) {
      onRemove(category.id);
    } else {
      onSelect(category);
    }
  };

  return (
    <div
      className={`flex justify-between items-center font-normal px-3 py-4 border rounded-2xl cursor-pointer ${
        isSelected ? "bg-white text-primaryButton border-primaryButton" : " text-DarkGrey3 bg-LightGrey1"
      }`}
      onClick={handleClick}
    >
      <span>{category.name}</span>
      <CheckCircle />
    </div>
  );
};

